import { CarpaySavedPaidOrders } from '@customTypes/carpaySavedPaidOrders'

export const SESSION_STORAGE_CARPAY_PAID_ORDERS = '@parkdepot/carpay_paid_orders'

export const SESSION_STORAGE_setCarpayPaidOrders = (ordersByPlate: CarpaySavedPaidOrders) => {
    sessionStorage.setItem(SESSION_STORAGE_CARPAY_PAID_ORDERS, JSON.stringify(ordersByPlate))
}

export const SESSION_STORAGE_emptyCarpayPaidOrders = () => {
    sessionStorage.removeItem(SESSION_STORAGE_CARPAY_PAID_ORDERS)
}

export const SESSION_STORAGE_getCarpayPaidOrders = (): CarpaySavedPaidOrders | null => {
    const paidOrdersInfo = sessionStorage.getItem(SESSION_STORAGE_CARPAY_PAID_ORDERS)
    return paidOrdersInfo ? JSON.parse(paidOrdersInfo) : null
}
